export const FETCH_AGENDA_REQUEST = "FETCH_AGENDA_REQUEST";
export const FETCH_AGENDA_SUCCESS = "FETCH_AGENDA_SUCCESS";
export const FETCH_AGENDA_FAILURE = "FETCH_AGENDA_FAILURE";
